document.addEventListener('DOMContentLoaded', () => {
	document.querySelectorAll('a[href*="#"]').forEach(link => {
		link.addEventListener('click', function ( e ) {
			let href = this.getAttribute('href').substring((this.getAttribute('href').indexOf('#')) + 1);

			const scrollTarget = document.getElementById(href);

			if ( scrollTarget !== null ) {
				e.preventDefault();

				const topOffset = window.innerWidth < 1024 ? document.querySelector('#wcl-header').offsetHeight : 0;
				const elementPosition = scrollTarget.getBoundingClientRect().top;
				const offsetPosition = elementPosition - (topOffset + 10);

				window.scrollBy({
					top: offsetPosition,
					behavior: 'smooth'
				});
			}
		});
	});
});
